import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vue from "vue";
import './plugins/vuetify'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from 'vuetify'
import UUID from 'vue-uuid';
import VueLodash from 'vue-lodash' 
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

// DEBUG
if (!window.location.host.startsWith("localhost")) {
  
  const bugsnagClient = bugsnag('306ccb08eb14c788bc3ed7eb358e1bfb')
  bugsnagClient.use(bugsnagVue, Vue)
  window.bugsnagClient = bugsnagClient;

  Vue.config.productionTip = true;
} else {
  Vue.config.productionTip = false;
}

Vue.use(UUID);
Vue.use(VueLodash)
Vue.use(require('vue-moment'));

// Define readonly form(box) types.
// This is a global mixin, it is applied to every vue instance
Vue.mixin({
  data: function() {
    return {
      get formTypes() {
        return {
        	checkbox  : 'checkbox' ,
					textbox   : 'textbox'  ,
					sliderbox : 'sliderbox',
					datebox   : 'datebox'  ,
					ratingbox : 'ratingbox',
					timebox   : 'timebox'  ,
					radiobox  : 'radiobox' ,
					photobox  : 'photobox' ,
					numberbox : 'numberbox'
        }
      }
    }
  }
});


// Redirect to non-hash URI if URI contains hash.
router.beforeEach((to, from, next) => {
  /* must call `next` */
  if (to.hash) {
    router.push(to.fullPath.replace("/#", ''));
  }
  // console.log(from)
  next()
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
